import React from "react";

import nary from "@/modules/nary";
import { assetImg } from "@/modules/moduleImporter";
import { ILanguageType } from "@/types/GlobalTypes";
import { IGenericHistoryType } from "@/types/GameHistoryTypes";
import Nnary from "@/modules/Nnary";

import "@/styles/machine_game_statistics.scss";

interface IProps {
	langdata: ILanguageType;
	mobile?: boolean;
	history: IGenericHistoryType[];
}

// Todo: set the styles

// Copied from m26
export default class M42 extends React.Component<IProps> {
	private get historyCount() {
		return this.props.history.length * 2;
	}

	private get processedHistory() {
		const
			output = nary(16).map(_ => 0),
			{ history } = this.props;

		for (const item of history) {
			const pair = item.angka.split(",");

			output[+pair[0]]++;
			output[+pair[1]]++;
		}

		return output;
	}

	// for desktop
	private genericFragment() {
		const { processedHistory, historyCount: total } = this;

		return (
			Nnary(0, 3).map(row =>
				<div className="row" key={"GS_m42_" + row}>
					{
						Nnary(0, 3).map(col => {
							const num = row * 4 + col;

							return (
								<div key={`GS_m42_${num}`}>
									{assetImg("m42", num + "")}

									<div>
										{Math.round(processedHistory[num] / total * 100)} %
									</div>
								</div>
							);
						})
					}
				</div>
			)
		)
	}

	private mobileFragment() {
		const { processedHistory, historyCount: total } = this;

		return (
			Nnary(0, 7).map(col =>
				<div className="row" key={"GS_m42_" + col}>
					{
						Nnary(0, 1).map(row => {
							const idx = col + row * 8;

							return (
								<div key={`GS_m42_${idx}`}>
									{assetImg("m42", idx + "")}

									<div>
										{Math.round(processedHistory[idx] / total * 100)} %
									</div>
								</div>
							);
						})
					}
				</div>
			)
		)
	}

	render() {
		return (
			<div className="game-statistics machine-game-statistics m42-statistics">
				{
					this.props.mobile
						? this.mobileFragment()
						: this.genericFragment()
				}
			</div>
		);
	}
}